// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1ssgs2fLqYS9SXwNJPkK7b","Body":"_2qQn_caSrPJHRP-dzdKEG9","Group":"_357r3ZL0tcz2YglnzWpdOO","Title":"_3J2DfD_WZqyx0nodp2f8ki","Column":"CUAaMrHj6ppjWo1gcoUFV","CheckboxWrap":"_1Or0K1DB7cUmOYtie2epGg","CustomCheckbox":"L0OABsVIhCVUfRLkiq4VV","InputIcon":"_3d8PC8Tv-8Q9WuE5fLRuG4","ActiveIcon":"_1fpdwcVyB-Ui92Z1kLunnM","BlockIcon":"_2M74Q4bBfLsmUGJRH3JH-r","InactiveIcon":"O9N6GW9Ko5qUc2D-spvcp","Footer":"mXVgSzfSZeUHT9CPDI9X0","Submit":"_2UFhVe_hLoLXdzQOfpvuqf","buttonIcon":"b_UbTIuzZpE2dkdm2VcS7"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/ProjectsFilters/styles.module.css
// module id = 547
// module chunks = 0